import { useIteroScanImages } from '../../../../../hooks/useIteroScanAssets';
import { browseErrorText } from '../browseErrorText';
import { useIteroBrowserScope } from '../iteroBrowserScope';
import { scanImageTab, type ScanImageTab, type ScanImageTabId } from './scanImageTabs';
import { scanImagesView, type ScanImagesView } from './scanPreviewState';
import { imageTally, type ImageTally } from './scanTally';
import type { ScanImage } from './scanZip';

export interface ScanImageSet {
    tab: ScanImageTab;
    view: ScanImagesView<ScanImage>;
    tally: ImageTally;
    retry: () => void;
}

export type ScanImageSets = Readonly<Record<ScanImageTabId, ScanImageSet>>;

function useScanImageSet(rxId: string, tab: ScanImageTab, enabled: boolean): ScanImageSet {
    const scope = useIteroBrowserScope();
    const query = useIteroScanImages(scope, rxId, tab.assetType, enabled);
    const view = scanImagesView({
        result: query.data,
        isFetching: query.isFetching,
        errorMessage: query.isError ? browseErrorText(query.error, tab.errorText) : null
    });
    return { tab, view, tally: imageTally(view), retry: () => void query.refetch() };
}

// Both sets load together when enabled, so the Scans tab and the Files rows can show both counts.
export function useScanImageSets(rxId: string, enabled: boolean): ScanImageSets {
    const modelViews = useScanImageSet(rxId, scanImageTab('model-views'), enabled);
    const screenCaptures = useScanImageSet(rxId, scanImageTab('screen-captures'), enabled);
    return { 'model-views': modelViews, 'screen-captures': screenCaptures };
}
